import { useContext } from 'react';
import WebSocketContext from 'src/contexts/WebSocketSFUContext';

const useWebSocket = () => useContext(WebSocketContext);

export default useWebSocket;
